import { render, staticRenderFns } from "./Update-Name.vue?vue&type=template&id=6ebfca3a&scoped=true&"
import script from "./Update-Name.vue?vue&type=script&lang=js&"
export * from "./Update-Name.vue?vue&type=script&lang=js&"
import style0 from "./Update-Name.vue?vue&type=style&index=0&id=6ebfca3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfca3a",
  null
  
)

export default component.exports